// Constants for social media URLs and handle types
export const baseUrls = {
  instagram: "https://www.instagram.com/",
  facebook: "https://www.facebook.com/",
  x: "https://x.com/",
  telegram: "https://t.me/",
  youtube: "https://www.youtube.com/",
  loco: "https://loco.co/",
  twitch: "https://www.twitch.tv/",
};

export const handleTypes = {
  instagram: "yourhandle",
  facebook: "handle",
  x: "handle",
  telegram: "yourhandle",
  youtube: "yourchannel",
  loco: "yourhandle",
  twitch: "yourchannel",
};

// Create regex pattern for social media URLs
export function createRegex(domain, path = "") {
  const escapedDomain = domain.replace(/\./g, "\\.");
  // Allow hyphens in handles
  return new RegExp(`^(https?:\/\/)?(www\.)?${escapedDomain}\/${path}[a-zA-Z0-9_.-]+\/?$`, "i");
}

// Generate placeholder examples
export function generateSocialMediaPlaceholders(urls, handles) {
  const result = {};
  for (const platform in urls) {
    result[platform] = `${urls[platform]}${handles[platform]}`;
  }
  return result;
}

// Generate error messages
export function generateSocialMediaErrorMessages(urls, handles) {
  const result = {};
  for (const platform in urls) {
    const platformName = capitalize(platform === "facebook" ? "Facebook" : platform);
    result[platform] =
      `Please enter a valid ${platformName} URL (e.g., ${urls[platform]}${handles[platform]}).`;
  }
  return result;
}

// Capitalize first letter of string
export function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// Initialize social media regex patterns
export const socialMediaRegex = {
  instagram: createRegex("instagram.com"),
  facebook: createRegex("facebook.com"),
  x: createRegex("x.com"),
  telegram: createRegex("t.me"),
  youtube: createRegex("youtube.com"),
  loco: createRegex("loco.co"),
  twitch: createRegex("twitch.tv"),
};

// Get platform details (regex, placeholder, error message)
export function getPlatformDetails(key) {
  const platform = key.toLowerCase();
  // Map 'facebook' key to 'facebookgaming' for consistency
  const effectivePlatform = platform === "facebook" ? "facebook" : platform;
  return {
    regex: socialMediaRegex[effectivePlatform],
    placeholder: generateSocialMediaPlaceholders(baseUrls, handleTypes)[effectivePlatform],
    errorMessage:
      generateSocialMediaErrorMessages(baseUrls, handleTypes)[effectivePlatform] ||
      "Enter a valid url",
  };
}

// Validate social media URL
export function validateSocialMediaUrl(url, platform) {
  if (!url) return "";
  url = url.trim(); // Trim whitespace
  const platformDetails = getPlatformDetails(platform);
  if (platformDetails.regex && !platformDetails.regex.test(url)) {
    return platformDetails.errorMessage;
  } else if (
    platform.toLowerCase() !== "website" &&
    platform.toLowerCase() !== "telegram" &&
    !url.toLowerCase().includes(platform.toLowerCase())
  ) {
    return "Enter url of respective field";
  }
  return "";
}
